"use strict";
var stompService1 = require('./dist/stomp.service');
exports.StompService = stompService1.StompService;


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/ng2-stomp-service/index.js
// module id = ../../../../ng2-stomp-service/index.js
// module chunks = 19